"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line no-use-before-define
const react_1 = __importStar(require("react"));
const use_query_params_1 = require("use-query-params");
const core_1 = require("@material-ui/core");
const queryParamsConfig_1 = __importDefault(require("./queryParamsConfig"));
const YearMonthSelectorView_1 = __importDefault(require("./YearMonthSelectorView"));
const StockInfosDownloaderView_1 = __importDefault(require("./Downloader/StockInfosDownloaderView"));
const PagedDataTableView_1 = __importDefault(require("./PagedDataTableView"));
const WarehouseSelector_1 = __importDefault(require("./WarehouseSelector"));
const DataTableField_1 = require("../../stockRecordWorkflow/ui/DataTableField");
const CreateStockInfosQuery_1 = __importDefault(require("./CreateStockInfosQuery"));
function StocksView({ hasCost, match, history, }) {
    const [message, setMessage] = react_1.useState('');
    const [open, setOpen] = react_1.useState(false);
    const [query, setQuery] = use_query_params_1.useQueryParams(queryParamsConfig_1.default);
    const [defaultWarehouseId, setDefaultWarehouseId] = react_1.useState(query.warehouseId);
    const { pageNum = 1, pageLimit = 10, year = new Date().getFullYear(), month = new Date().getMonth() + 1, onlyNegative = false, filter = '', } = query;
    const warehouseId = query.warehouseId === undefined ? defaultWarehouseId : query.warehouseId;
    const stockInfosQuery = CreateStockInfosQuery_1.default(onlyNegative, {
        hasCost,
        year,
        month,
        filter,
        warehouseId,
    });
    const { loading: isLoading, error, data, } = stockInfosQuery.query(pageNum, pageLimit);
    if (error)
        return react_1.default.createElement("div", null, error);
    const setFilter = (value) => {
        setQuery({
            filter: value,
            pageNum: 1,
            onlyNegative: false,
        });
    };
    const setPageNum = (value) => {
        setQuery({ pageNum: value });
    };
    const setPageLimit = (value) => {
        setQuery({ pageLimit: value });
    };
    const onMouseUp = (index) => {
        if (data === undefined)
            throw new Error('Data is not ready');
        history.push(`${match.url.replace(/\/$/, '')}/${stockInfosQuery.parse(data)[index].stockInfoId}?${use_query_params_1.stringify(query)}`);
    };
    const header = {
        getUniqueId: (stockInfo) => {
            if (stockInfo.stockInfoId === undefined) {
                throw new Error('stockInfoId is undefined.');
            }
            return stockInfo.stockInfoId;
        },
    };
    const fields = [
        {
            label: '商品代號',
            width: 240,
            textAlign: DataTableField_1.TextAlignment.Left,
            toFormat(info) {
                return info.stock.product.key;
            },
            copyable: true,
        },
        {
            label: '商品名稱',
            width: 500,
            textAlign: DataTableField_1.TextAlignment.Left,
            toFormat(info) {
                return info.stock.product.name;
            },
        },
        {
            label: '倉儲位置',
            width: 200,
            textAlign: DataTableField_1.TextAlignment.Left,
            toFormat(info) {
                if (info.stock.warehouse === undefined)
                    throw new Error('Warehouse is undefined');
                return info.stock.warehouse;
            },
        },
        {
            label: '庫存數量',
            width: 80,
            textAlign: DataTableField_1.TextAlignment.Right,
            toFormat: (info) => {
                if (info.qty === undefined || info.qty === null) {
                    return 'N/A';
                }
                return info.qty.toString();
            },
        },
    ];
    if (hasCost) {
        fields.push({
            label: '平均成本',
            width: 80,
            textAlign: DataTableField_1.TextAlignment.Right,
            toFormat: (info) => {
                if (info.averageCost === undefined || info.averageCost === null) {
                    return 'N/A';
                }
                return (Math.round(info.averageCost * 100) / 100).toString();
            },
        });
    }
    const onMessageCreated = (msg) => {
        setMessage(msg);
        setOpen(true);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", null,
            react_1.default.createElement(YearMonthSelectorView_1.default, { year: year, month: month, setYear: (y) => {
                    setQuery({ year: y });
                }, setMonth: (m) => {
                    setQuery({ month: m });
                } }),
            react_1.default.createElement("span", { style: { paddingLeft: '10px' } },
                react_1.default.createElement(WarehouseSelector_1.default, { warehouseId: warehouseId, setDefaultWarehouseId: (val) => {
                        setDefaultWarehouseId(val);
                    }, setWarehouseId: (val) => {
                        setQuery({
                            warehouseId: val,
                        });
                    } })),
            defaultWarehouseId && hasCost
                && react_1.default.createElement(StockInfosDownloaderView_1.default, { datastore: stockInfosQuery }),
            hasCost && (react_1.default.createElement(core_1.FormControlLabel, { control: (react_1.default.createElement(core_1.Switch, { checked: onlyNegative, onChange: (e) => {
                        setQuery({
                            onlyNegative: e.target.checked,
                            filter: e.target.checked ? '' : filter,
                        });
                    }, name: "negativeOnly", color: "primary" })), label: "\u53EA\u986F\u793A\u8CA0\u5EAB\u5B58" }))),
        react_1.default.createElement(PagedDataTableView_1.default, { pageNum: pageNum, pageLimit: pageLimit, setPageNum: setPageNum, setPageLimit: setPageLimit, defaultFilter: filter, setFilter: setFilter, isLoading: isLoading, header: header, fields: fields, data: data === undefined ? [] : stockInfosQuery.parse(data), onMouseUp: onMouseUp, onMessageSent: onMessageCreated }),
        react_1.default.createElement(core_1.Snackbar, { open: open, onClose: () => setOpen(false), autoHideDuration: 1000, message: react_1.default.createElement(react_1.default.Fragment, null, message) })));
}
exports.default = StocksView;
